export default __webpack_public_path__ + "static/media/fwaction.641fc7b3.png";